"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("../../../node_modules/graphql-tag/lib/index.js").gql`
    mutation addLikedFeatureService($likedFeature: LikedFeatureInput!) {
        createLikedFeature(input: { likedFeature: $likedFeature }) {
            feature {
                type
                url
                name
                featureId
            }
        }
    }
`;exports.addFeature=e;
//# sourceMappingURL=queries.js.map
